
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/user/[accountTab]",
      function () {
        return require("private-next-pages/stores/[cName]/user/[accountTab].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/user/[accountTab]"])
      });
    }
  